// 1_utils/go_top_btn.js
// Exposes window.NAT.utils.goTopBtn(): wires the .goToTop__button to smooth-scroll
// the page to the top. Invoked on DOMContentLoaded and Shoptet's DOM-ready event.

window.NAT = window.NAT || {};
window.NAT.utils = window.NAT.utils || {};

window.NAT.utils.goTopBtn = function () {
	const goTopBtn = document.querySelector(".goToTop__button");
	if (!goTopBtn) return;

	goTopBtn.addEventListener("click", (e) => {
		e.preventDefault();
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	});
};

document.addEventListener("DOMContentLoaded", () => {
	window.NAT.utils.goTopBtn();
});
document.addEventListener("ShoptetDOMContentLoaded", () => {
	window.NAT.utils.goTopBtn();
});
